import React, {useEffect} from 'react'
import {useDispatch} from 'react-redux'
import {Redirect, Switch} from 'react-router-dom'
import * as auth from './redux/AuthRedux'
import {productsReducer, driverReducer, workspaceReducer}  from "../../@reducer"
import {PATH_AUTH} from '../../routing/paths'

export function Logout() {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(auth.actions.logout())
    dispatch(productsReducer.actions.clearProductsActive())
    dispatch(driverReducer.actions.resetTour())
    dispatch(workspaceReducer.actions.clearWorkspace())
    document.location.reload()
  }, [dispatch])

  return (
    <Switch>
      <Redirect to={PATH_AUTH.login} />
    </Switch>
  )
}
